import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() { }

  // could be used later to track errors with external tools
  logError(message: string, stack?: string) {
    console.log('LoggingService (E): ' + message, stack);
  }

  logInfo(message: string) {
    console.log('LoggingService(I): ' + message)
  }

  logDebug(message: string) {
    console.log('LoggingService(D): ' + message);
  }
}
